import { Button } from '@mui/material';
import React, { MouseEventHandler } from 'react';

const CustomButton: React.FC<{
   type?: "submit" | "reset" | "button" | undefined;
    disabled: boolean; 
    lable: string; 
    infoContent: string; size?: 'small' | 'medium' | 'large';
    onClick?: MouseEventHandler | undefined;
   }> = ({ type, disabled, lable, infoContent, size = 'small',onClick }) => {
  return (
      <Button onClick={onClick} type={type} disabled={disabled} variant="contained" color="success" size={size} sx={{ marginLeft: '5px', marginRight: '5px', textTransform: 'none' }}>
        {lable}
      </Button>
  );
};


export default CustomButton;
